import { BookOpen } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function DictionariesPage() {
  return (
    <PlaceholderPage
      icon={BookOpen}
      title="S\u0142owniki"
      description="Zarz\u0105dzaj s\u0142ownikami systemowymi \u2014 statusy, bran\u017Ce, \u017Ar\u00F3d\u0142a pozyskania i inne pola wyboru."
    />
  )
}
